

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
interface HolderChange {
    name: string;
    beforePercent: string;
    afterPercent: string;
    changeDate: string;
    id?: number;
    accountBookId: number;
    year: number | string;
}

@Component
export default class Gqbg extends Vue {
    @Prop({ default: new Date().getFullYear() - 1 })
    year!: number;

    form: HolderChange = {
        name: "",
        beforePercent: "",
        afterPercent: "",
        changeDate: "",
        accountBookId: this.$store.state.accountBook.id,
        year: this.year
    }

    dataList = <HolderChange[]>[];

    mounted() {
        this.fetchData();
    }

    resetForm() {
        this.form = {
            name: "",
            beforePercent: "",
            afterPercent: "",
            changeDate: "",
            accountBookId: this.$store.state.accountBook.id,
            year: this.year
        }
    }

    async fetchData() {
        const res = await Vue.axios.get(`gsnb/gqbgxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        this.dataList = res.data.data;
    }

    async saveData(isEdit = false, data?: HolderChange) {
        const orgData = isEdit && data ? data : this.form;

        if (!isEdit) {
            const keys = Object.keys(orgData);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                // @ts-ignore
                const value = orgData[key];
                if (value === null || value === "") return;
            }
        }
        await Vue.axios.post("gsnb/gqbgxx/save ", orgData);
        await this.fetchData();
        if (!isEdit) this.resetForm();
    }

    async deleteData(id: number) {
        try {
            const action = await this.$confirm("确定要删除这条记录吗?", "温馨提示");
            if (action === "confirm") {
                await Vue.axios.delete(`gsnb/gqbgxx/delete?id=${id}`);
                this.fetchData();
            }
        } catch (e) {

        }
    }
}
